import type {
  PartnerCreditApproval,
  PartnerCreditCertification,
  PartnerCreditConfiguration,
  PartnerCreditVersion,
} from './types';

export const partnerCreditPartnerId = '00000000-0000-4000-8000-000000000101';
export const partnerCreditApprovalId = '00000000-0000-4000-8000-000000001511';
const actorId = '00000000-0000-4000-8000-000000000001';

export const partnerCreditVersionFixture: PartnerCreditVersion = Object.freeze({
  id: '00000000-0000-4000-8000-000000001501',
  version: 3,
  configuration: {
    name: 'Production credit delivery',
    creditEndpoint: 'https://partner.example/credits',
    statusEndpoint: 'https://partner.example/credits/{transferId}',
    healthEndpoint: 'https://partner.example/health',
    authType: 'HMAC_API_KEY' as const,
    hmacKeyId: 'key-ref-prod-a',
    timeoutMilliseconds: 5000,
    retryPolicy: {
      maximumAttempts: 5,
      initialDelaySeconds: 2,
      maximumDelaySeconds: 60,
      multiplier: 2,
      jitterPercent: 20,
    },
  },
  effectiveFrom: '2026-07-23T10:00:00+07:00',
  effectiveTo: null,
  certifiedAt: '2026-07-23T09:45:00+07:00',
  publishedAt: '2026-07-23T09:50:00+07:00',
  publishedBy: actorId,
});

export const partnerCreditConfigurationFixture: PartnerCreditConfiguration = Object.freeze({
  id: '00000000-0000-4000-8000-000000001500',
  partnerId: partnerCreditPartnerId,
  name: 'Production credit delivery',
  status: 'ACTIVE',
  currentVersion: partnerCreditVersionFixture,
  createdAt: '2026-07-20T10:00:00+07:00',
  createdBy: actorId,
  updatedAt: '2026-07-23T10:00:00+07:00',
  updatedBy: actorId,
});

export const partnerCreditApprovalFixture: PartnerCreditApproval = Object.freeze({
  id: partnerCreditApprovalId,
  partnerId: partnerCreditPartnerId,
  actionType: 'PARTNER_CREDIT_PUBLISH',
  entityType: 'PARTNER_CREDIT_INTEGRATION',
  entityId: partnerCreditConfigurationFixture.id,
  reason: 'Rotate production authentication material',
  evidenceReference: null,
  status: 'PENDING',
  requestedBy: actorId,
  requestedAt: '2026-07-23T09:30:00+07:00',
  expiresAt: '2026-07-24T09:30:00+07:00',
  decidedBy: null,
  decidedAt: null,
  decisionReason: null,
  executedAt: null,
  executionReference: null,
});

export const partnerCreditCertificationFixture: PartnerCreditCertification = Object.freeze({
  id: '00000000-0000-4000-8000-000000001512',
  approvalRequestId: partnerCreditApprovalId,
  passed: true,
  healthHttpStatus: 204,
  statusHttpStatus: 200,
  checkedAt: '2026-07-23T09:40:00+07:00',
});
